<template>
  <b-modal
    id="ReservationScheduleCancel"
    scrollable
    size="lg"
    centered
    hide-footer
  >
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <template #modal-title>
      <h3>
        <img src="@/assets/images/cancel.svg" class="icon-lg" />
        {{ $t("reservations.cancel") }}
      </h3>
    </template>

    <form autocomplete="off" method="post">
      <div class="row">
        <CustomSelectBox
          :className="'col-lg-6'"
          :id="'methodPaidToken'"
          :value="reservationSchedulesCancelData.methodPaidToken"
          :options="methodPaidTokenOptions"
          v-on:changeValue="
            reservationSchedulesCancelData.methodPaidToken = $event
          "
          :title="$t('methodPaidSelect')"
          :imgName="'method-paids.svg'"
        />
        <CustomInputFloat
          :className="'col-lg-6'"
          :id="'refundPercentageFromPaid'"
          :value="reservationSchedulesCancelData.refundPercentageFromPaid"
          v-on:changeValue="
            reservationSchedulesCancelData.refundPercentageFromPaid = $event
          "
          :title="$t('reservations.refundPercentageFromPaid')"
          :imgName="'percentage.svg'"
        />

        <TextArea
          :className="'col-lg-6'"
          :id="'cancelReasonAr'"
          :value="reservationSchedulesCancelData.cancelReasonAr"
          v-on:changeValue="
            reservationSchedulesCancelData.cancelReasonAr = $event
          "
          :title="$t('reservations.cancelReasonAr')"
          :imgName="'reason.svg'"
        />
        <TextArea
          :className="'col-lg-6'"
          :id="'cancelReasonEn'"
          :value="reservationSchedulesCancelData.cancelReasonEn"
          v-on:changeValue="
            reservationSchedulesCancelData.cancelReasonEn = $event
          "
          :title="$t('reservations.cancelReasonEn')"
          :imgName="'reason.svg'"
        />
        <TextArea
          :className="'col-lg-6'"
          :id="'cancelReasonUnd'"
          :value="reservationSchedulesCancelData.cancelReasonUnd"
          v-on:changeValue="
            reservationSchedulesCancelData.cancelReasonUnd = $event
          "
          :title="$t('reservations.cancelReasonUnd')"
          :imgName="'reason.svg'"
        />
        <TextArea
          :className="'col-lg-6'"
          :id="'cancelNote'"
          :value="reservationSchedulesCancelData.cancelNote"
          v-on:changeValue="reservationSchedulesCancelData.cancelNote = $event"
          :title="$t('notes')"
          :imgName="'notes.svg'"
        />
      </div>

      <div class="form-footer">
        <button
          name="submit"
          type="submit"
          class="btn btn-submit"
          @click.prevent="cancelReservation"
        >
          {{ $t("ok") }}
        </button>
        <button
          name="submit"
          type="submit"
          class="btn btn-cancel"
          @click.prevent="$bvModal.hide('ReservationScheduleCancel')"
        >
          {{ $t("cancel") }}
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import CustomInputFloat from "@/components/general/CustomInputFloat.vue";
import CustomSelectBox from "@/components/general/CustomSelectBox.vue";
import TextArea from "@/components/general/TextArea.vue";
import PaymentMethode from "@/models/settings/settingsOther/paymentMethodes/PaymentMethode";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "ReservationScheduleCancel",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    CustomInputFloat,
    CustomSelectBox,
    TextArea,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      methodPaidData: new PaymentMethode(),
      methodPaidTokenOptions: [],
    };
  },
  methods: {
    async cancelReservation() {
      this.isLoading = true;
      try {
        let response =
          await this.reservationSchedulesCancelData.cancelReservation(
            this.language,
            this.userAuthorizeToken
          );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.$bvModal.hide("ReservationScheduleCancel");
          this.$emit("refresh");
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        console.log(e);
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
    async getDialogOfPaymentMethodes() {
      this.isLoading = true;
      this.methodPaidTokenOptions = [];
      this.methodPaidTokenOptions.push({
        value: "",
        text: this.$t("methodPaidSelect"),
      });
      try {
        let response = await this.methodPaidData.getDialogOfPaymentMethodes(
          this.language,
          this.userAuthorizeToken
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.methodPaidTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text: itemsData[item]["itemName"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("updateUserData", null);
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  props: ["reservationSchedulesCancelData"],
  computed: {},
  async created() {
    this.getDialogOfPaymentMethodes();
  },
};
</script>

<style scoped lang="scss"></style>
